import { DiscriminationOfAllSubjects } from './DiscriminationOfAllSubjects';
export default DiscriminationOfAllSubjects;
